export default {"src":"/_next/static/media/scikit.3c999cb6.svg","height":150,"width":277};